// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'jquery';
import 'bootstrap/dist/js/bootstrap';
import 'tether';
import Vue from 'vue';
import VueParallaxJs from 'vue-parallax-js';
import App from './App';
import router from './router';

Vue.config.productionTip = false;
Vue.use(VueParallaxJs);

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js